const ExtendedLabel = require('ExtendedLabel');
const BasePrizeController = require('BasePrizeController');

const PRIZE_HIDE_DURATION = 0.1;

cc.Class({
    extends: BasePrizeController,

    properties: {
        label: ExtendedLabel,

        font: cc.BitmapFont
    },

    showPrize (prize, betAmount) {
        this.node.active = true;
        this.prize = prize;
        this.betAmount = betAmount;

        this.label.setFontData(this.font, 18);
        this.label.setNumber(prize);
    },

    hide () {
        this.label.hide(PRIZE_HIDE_DURATION).then(() => {
            this.node.active = false;
        });
    }
});
